export default "__VITE_ASSET__DGQZGjCW__"